import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { AssetsService } from "../assets.service";
import { MessagesService } from "../../messages.service";
import * as XLSX from 'xlsx';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-notlocated',
  templateUrl: './notlocated.component.html',
  styleUrls: ['./notlocated.component.css']
})
export class NotlocatedComponent implements OnInit {

  /*Filtros */
    public assetsSearchCriteria: any;

    public materials: any[];
    public containers: any[];
    public dropdownSettings = {
        singleSelection: true,
        text: 'Seleccione',
        enableSearchFilter: true,
        enableFilterSelectAll: false,
        searchPlaceholderText: 'Buscar',
        showCheckbox: true,
        noDataLabel: 'Sin registros'
    };

    /*Procesamiento*/
    public countFilters: Number;
    public loadingFilters: Boolean;
    public loadingGraphs: Boolean;
    public loadingResults: Boolean;

    /*Respuesta*/
    public isFiltered: Boolean;
    public filteredDate: Date;
    public page: number = 1;
    public total: number = 0;
    public assets: any[];

    constructor(private assetsService: AssetsService, private router: Router, private route: ActivatedRoute, private messagesService: MessagesService) { }

    ngOnInit() {
        this.assetsSearchCriteria = {
            "currentLocationId": null,
            "materialCode": null,
            "containerCode": null,
            "statusCode": null
        };
        this.initLoading();
        //Ver si hay que autocompletar con filtros de la navegación
        this.isFiltered = false;
        this.filteredDate = null;
        this.assets = [];
        if (this.route.snapshot.queryParamMap.get('autosearch')) {
            this.search();
        }
    }

    private initLoading() {
        this.countFilters = 2;
        this.loadingFilters = true;
        this.loadMaterials();
        this.loadContainers();
    }

    loadMaterials() {
        this.assetsService.getMaterials().subscribe(
            data => { this.checkLoading(); this.materials = data.map(l => ({ id: l.code, itemName: l.code + ' - ' + l.description })); },
            error => { this.checkLoading(); this.materials = []; this.checkError(error, 'Ha ocurrido un error al cargar los productos') }
        );
    }

    loadContainers() {
        this.assetsService.getContainers().subscribe(
            data => { this.checkLoading(); this.containers = data.map(l => ({ id: l.code, itemName: l.code + ' - ' + l.description })); },
            error => { this.checkLoading(); this.containers = []; this.checkError(error, 'Ha ocurrido un error al cargar los envases') }
        );
    }

    private checkLoading() {
        this.countFilters = (this.countFilters.valueOf() - 1);
        if (this.countFilters == 0) {
            this.loadingFilters = false;
        }
    }

    private checkError(error: any, defaultMessage: string) {
        this.messagesService.checkError(error, defaultMessage);
    }

    public search(): void {
        let searchCriteria = {
            "currentLocationId": null,
            "materialCode": (this.assetsSearchCriteria.materialCode && this.assetsSearchCriteria.materialCode[0]) ? this.assetsSearchCriteria.materialCode[0].id : null,
            "containerCode": (this.assetsSearchCriteria.containerCode && this.assetsSearchCriteria.containerCode[0]) ? this.assetsSearchCriteria.containerCode[0].id : null,
            "statusCode": null
        };
        this.isFiltered = true;
        this.loadingResults = true;
        this.assetsService.getAssetsNotAllocated(searchCriteria).subscribe(
            data => { this.loadingResults = false; this.assets = data; this.page = 1; this.filteredDate = new Date(); },
            error => { this.loadingResults = false; this.checkError(error, 'Ha ocurrido un error al buscar los activos'); }
        );
    }

    public download(): void {
        this.loadingResults = true;
        let exportable = new Array();
        exportable.push(["# Serial","Producto", "Desc. Producto", "Envase", "Desc. Envase", "#Ref. Despacho", "Fecha despacho"]);
        this.assets.forEach(function (asset) {
            exportable.push(
             [  asset.serialNumber,
                            asset.material.code,
                            asset.material.description,
                            asset.material.code,
                            asset.material.description,
                            asset.dispatchNumber,
                            moment(asset.dispatchDate).format('YYYY-MM-DD H:mm')]
            );
        });
        const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(exportable);
        const wb: XLSX.WorkBook = { Sheets: { 'Sin ubicación': ws }, SheetNames: ['Sin ubicación'] };
        XLSX.writeFile(wb, 'Sin_ubicación_' + moment(this.filteredDate).format('YYYY-MM-DD_H:mm') + '.xls', { bookType: 'xls', type: 'buffer' });
        
        
        this.loadingResults = false;
    }

}
